'use client';

import { c as _c } from "react/compiler-runtime";
import type { Post } from '@shared/all/domains/posts';
import usePostsShared from '@shared/utils/hooks/usePosts';
import { useInfiniteQuery } from '@tanstack/react-query';
import { client } from '../../../utils/trpc';
import Modal, { ModalHeader } from '../../HOC/Modal';
import PostItem from '../PostItem';
import RepliesContainer from '../RepliesContainer';
import { AvatarWithSettings } from './AvatarWithSettings';
import { useNewPostContext } from './NewPostContext';
import { NewPostInputSection } from './NewPostInputSection';
export const TopLevelReplyLayout = () => {
  const $ = _c(32);
  const {
    closeOrSaveDraft,
    parentPostId,
    parentIsPrivate,
    uniqueId,
    scrollAreaRef
  } = useNewPostContext();
  const {
    queryKey,
    isNsfw,
    isPolitics,
    fetchPrivatePost
  } = usePostsShared(client, uniqueId);
  let t0;
  if ($[0] !== fetchPrivatePost || $[1] !== parentIsPrivate || $[2] !== parentPostId) {
    t0 = async () => {
      if (parentIsPrivate) {
        const post = await fetchPrivatePost(parentPostId);
        if (!post) {
          throw new Error("Private post not found");
        }
        return {
          posts: [post]
        };
      }
      const [error, result] = await client.posts.singlePost.query({
        postId: parentPostId
      });
      if (error) {
        throw error;
      }
      return result;
    };
    $[0] = fetchPrivatePost;
    $[1] = parentIsPrivate;
    $[2] = parentPostId;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const t1 = Boolean(parentPostId);
  let t2;
  if ($[4] !== queryKey || $[5] !== t0 || $[6] !== t1) {
    t2 = {
      queryKey,
      queryFn: t0,
      initialPageParam: 0,
      getNextPageParam: _temp,
      enabled: t1,
      staleTime: 300000
    };
    $[4] = queryKey;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const {
    data,
    isLoading
  } = useInfiniteQuery(t2);
  const replyPostData = data?.pages[0]?.posts[0];
  let t3;
  if ($[8] !== closeOrSaveDraft) {
    t3 = <ModalHeader closeHandler={closeOrSaveDraft}>Reply</ModalHeader>;
    $[8] = closeOrSaveDraft;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== isLoading || $[11] !== isNsfw || $[12] !== isPolitics || $[13] !== replyPostData || $[14] !== uniqueId) {
    t4 = isLoading && !replyPostData ? <div className="flex items-center justify-center py-8"><div className="loader" /></div> : replyPostData ? <><PostItem post={replyPostData} isFullLength={true} disableLink={true} disableReply={true} isInView={false} uniqueId={uniqueId} />{replyPostData.replies_count > 0 && <RepliesContainer post={replyPostData as Post & {
        replies: Post[];
      }} isFullLength={false} disableLink={false} uniqueId={uniqueId} isPoliticsParent={isPolitics(replyPostData.postFactiiisCount, replyPostData.space)} isNsfwParent={isNsfw(replyPostData.postFactiiisCount)} />}</> : null;
    $[10] = isLoading;
    $[11] = isNsfw;
    $[12] = isPolitics;
    $[13] = replyPostData;
    $[14] = uniqueId;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== scrollAreaRef || $[17] !== t4) {
    t5 = <div ref={scrollAreaRef} className="min-h-0 flex-1 overflow-y-auto p-4">{t4}</div>;
    $[16] = scrollAreaRef;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  const t6 = !parentIsPrivate;
  let t7;
  if ($[19] !== parentIsPrivate || $[20] !== t6) {
    t7 = <AvatarWithSettings hidePrivate={t6} parentIsPrivate={parentIsPrivate} size={35} />;
    $[19] = parentIsPrivate;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="min-w-0 flex-1 rounded-xl bg-background-secondary px-2 py-1.5"><NewPostInputSection /></div>;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t7) {
    t9 = <div className="shrink-0 border-t border-ds-border-subtle p-3 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.2)]"><div className="flex items-start gap-2">{t7}{t8}</div></div>;
    $[23] = t7;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t3 || $[26] !== t5 || $[27] !== t9) {
    t10 = <div className="flex max-h-[85vh] flex-col">{t3}{t5}{t9}</div>;
    $[25] = t3;
    $[26] = t5;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== closeOrSaveDraft || $[30] !== t10) {
    t11 = <Modal maxWidth={700} closeHandler={closeOrSaveDraft}>{t10}</Modal>;
    $[29] = closeOrSaveDraft;
    $[30] = t10;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
};
function _temp() {}